import {useState} from 'react'
import {useGodModeReadOnly} from '@/hooks/platform/use-god-mode'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {
  useConsentMyPerfilSociodemografico,
  type PerfilSociodemografico as PerfilRead,
} from '@/hooks/empresa/mi_espacio/use-perfil-sociodemografico'
import {translateApiError} from '@/lib/errors'

export function ConsentStep({businessId, onConsented}: {businessId: string; onConsented: () => void}) {
  const {t} = useTranslation()
  const godReadOnly = useGodModeReadOnly()
  const consent = useConsentMyPerfilSociodemografico(businessId)
  const [error, setError] = useState<string | null>(null)
  function accept() {
    setError(null)
    consent.mutate(undefined, {onSuccess: onConsented, onError: (err) => setError(translateApiError(err))})
  }
  return (
    <div className="space-y-4" data-testid="perfil-sociodemografico-consent-step">
      <p className="text-sm whitespace-pre-line text-foreground">{t('perfilSociodemografico.consent.body')}</p>
      <Button
        type="button"
        size="sm"
        disabled={consent.isPending || godReadOnly}
        onClick={accept}
        data-testid="perfil-sociodemografico-consent-accept">
        {t('perfilSociodemografico.consent.accept')}
      </Button>
      {error && (
        <p className="text-sm text-destructive" data-testid="perfil-sociodemografico-consent-error">
          {error}
        </p>
      )}
    </div>
  )
}

export function SealedNotice({perfil}: {perfil: PerfilRead}) {
  const {t} = useTranslation()
  return (
    <p className="notice-amber rounded-lg px-3 py-2 text-xs" data-testid="perfil-sociodemografico-sealed-notice">
      {t('perfilSociodemografico.sealedNotice', {date: perfil.sealed_at ? perfil.sealed_at.slice(0, 10) : ''})}
    </p>
  )
}
